export const alertsModule = [
  {
    path: '/alerts.ashx',
    loaderBundle: () => import(/* webpackChunkName: "alerts-loaders" */ './loaders'),
    LazyComponent: () => import(/* webpackChunkName: "alerts" */ './AlertsRoute'),
  },
]
